import { render, staticRenderFns } from "./DataIndicator.vue?vue&type=template&id=79934c83&scoped=true&"
import script from "./DataIndicator.vue?vue&type=script&lang=ts&"
export * from "./DataIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./DataIndicator.vue?vue&type=style&index=0&id=79934c83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79934c83",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDivider,VIcon,VProgressCircular,VTooltip})
